import { Messages } from '../../../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../../../settings/types/ISite';
import { SiteAvailabilityState } from '../../../../sites/SitePropertyTypes';
import { suspendSite } from '../../../actions/spaces/SiteMenuActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { canChangeSiteAvailability } from './IEntityActionHelpers';

export const SuspendSiteAction: IEntityAction<ISiteSettingsForServerAdmin, {}> = {
  name: EntityActionNames.SuspendSite,
  translateName: Messages.suspend_action,
  isVisible: (targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteSettingsForServerAdmin[]) => {
    return canChangeSiteAvailability(targetItems, SiteAvailabilityState.SUSPENDED);
  },
  createReduxAction: (targetItems: ISiteSettingsForServerAdmin[]) => suspendSite(targetItems)
};
